/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mentions_Insert_FailedInputs */



/**
* | output |
* | --- |
* | "Could not insert the mention. Type @ and pick it again." |
*
* @param {Chat_Mentions_Insert_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_insert_failed = /** @type {((inputs?: Chat_Mentions_Insert_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Insert_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erwähnung konnte nicht eingefügt werden. Bitte @ erneut eingeben und auswählen.")
	return /** @type {LocalizedString} */ ("Could not insert the mention. Type @ and pick it again.")
});